import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { BehaviorSubject, EMPTY, Observable, of, throwError } from 'rxjs';
import { User } from '../_models';
import { Role } from '../_models/role';
import { UserResolver } from '../_helpers/user.resolver';

@Injectable()
export class AuthenticationService {
  // private loggedIn = new BehaviorSubject<boolean>(!!localStorage.getItem('currentUser'));
  private _loggedUser = new BehaviorSubject<User>(this.getStoredUser());

  // get isLoggedIn(): Observable<boolean> {
  //   return this.loggedIn.asObservable();
  // }

  get loggedUser(): Observable<User> {
    return this._loggedUser.asObservable();
  }

  private getStoredUser(): User {
    return localStorage.getItem('currentUser') ? JSON.parse(localStorage.getItem('currentUser')) : undefined;
  }

  constructor(private http: HttpClient) {}

  login(username: string, password: string): Observable<User> {
    return this.http
      .post<any>(`/authenticate`, { username, password })
      .pipe(
        catchError((errorResponse: HttpErrorResponse) => {
          return throwError(new Error(`Unauthorized (${errorResponse.status}): ${errorResponse.message}`));
        }),
        map((user) => {
          // login successful if there's a jwt token in the response
          if (user && user.token) {
            // store user details and jwt token in local storage to keep user logged in between page refreshes
            localStorage.setItem('currentUser', JSON.stringify(user));
            this._loggedUser.next(user);
            return user;
          }
          return throwError(new Error('Invalid response'));
        })
      );
  }

  register(user: User): Observable<void> {
    return this.http.post<void>(`/register`, user);
  }

  logout(): void {
    // remove user from local storage to log user out
    localStorage.removeItem('currentUser');
    this._loggedUser.next(undefined);
  }
}
